import { IonButton } from "@ionic/react";

interface Props {
  setPreviousExerciseModal: Function;
  selectedExercisePlan: any;
}
const PreviousExerciseModal: React.FC<Props> = ({
  setPreviousExerciseModal,
  selectedExercisePlan,
}) => {
  return (
    <>
      <div className="all-generic-new-modal-center w-468-for-modal">
        <div className="previous-exercise-modal">
          <div className="cross-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
              onClick={() => setPreviousExerciseModal(false)}
            >
              <path
                d="M15.9999 15.9999L3 3"
                stroke="#D1D1D1"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16 3L3 16"
                stroke="#D1D1D1"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h2>{selectedExercisePlan.recommendationDateToPrint}</h2>
          <ul>
            {selectedExercisePlan.exercisesNames.map(
              (exercise: any, index: number) => {
                return (
                  <li key={index}>
                    <span>{exercise}</span>
                  </li>
                );
              }
            )}
          </ul>
          <IonButton
            placeholder={undefined}
            className="generic-btn bg-blue"
            onClick={() => setPreviousExerciseModal(false)}
          >
            Close
          </IonButton>
        </div>
      </div>
    </>
  );
};
export default PreviousExerciseModal;
